export const timezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
